import {
  createInsight,
  queryInsight,
  updateInsight,
} from '@wix/ambassador-genie-v1-insight/http';
import type {
  CreateInsightRequest,
  Insight,
  QueryInsightResponse,
} from '@wix/ambassador-genie-v1-insight/build/cjs/types.impl';
import { ErrorReporter } from '@wix/editor-error-reporter';
import { HttpClient } from '@wix/http-client';

const BUSINESS_INSIGHT_SOURCE = 'SITE_TEMPLATE';
const getInsight = async (httpClient: HttpClient) => {
  let insight: Insight | undefined;
  const queryInsightRequest = {
    query: {},
  };
  try {
    const {
      data: { insights },
    } = await httpClient.request<QueryInsightResponse>(
      queryInsight(queryInsightRequest),
    );

    insight = Array.isArray(insights) ? insights[0] : insights;
  } catch (error: unknown) {
    ErrorReporter.captureException(error);
  }

  return insight;
};

export const createOrUpdateSiteInsight = async (
  httpClient: HttpClient,
  businessDescription?: string,
) => {
  const insight = await getInsight(httpClient);

  if (!insight) {
    const newInsight: CreateInsightRequest = {
      insight: {
        source: BUSINESS_INSIGHT_SOURCE,
        content: businessDescription,
      },
    };
    await httpClient.request(createInsight(newInsight));
    return;
  }

  await httpClient.request(
    updateInsight({
      insight: { ...insight, content: businessDescription },
      mask: ['content'],
    }),
  );
};
